export default "__VITE_ASSET__CTZJO47m__"